/**
 * Constructs a URL object from the given base and path arguments and assigns the search params
 * @returns URL
 */
const buildURL = (base, path, search) => {
    // some customers may have urls like https://api.poolsi.de/path/
    // so we need to ensure that we build to support that use case
    const url = new URL(base.replace(/\/$/, "") + "/" + path.replace(/^\/+/, ""));
    for (const [k, v] of new URLSearchParams(search)) {
        url.searchParams.append(k, v);
    }
    return url;
};
export { buildURL };
